import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import './ToolPage.css'
import { decryptText } from './utils/burnCrypto'
import { consumeBurnMessage } from './utils/burnMessageStore'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const BurnMessageReveal = () => {
  useDocumentMeta({
    title: 'Ler Texto Temporário  jarder.dev',
    description: 'Revele uma mensagem que só pode ser lida uma única vez.',
  })

  const location = useLocation()
  const [status, setStatus] = useState('idle')
  const [message, setMessage] = useState('')

  const params = new URLSearchParams(location.search)
  const id = params.get('id')
  const keyBase64Url = location.hash.slice(1)

  const reveal = async () => {
    if (!id || !keyBase64Url) {
      setStatus('invalid')
      return
    }
    setStatus('loading')
    try {
      const record = await consumeBurnMessage(id)
      if (!record) {
        setStatus('gone')
        return
      }
      const text = await decryptText({
        ciphertext: record.ciphertext,
        iv: record.iv,
        keyBase64Url,
      })
      setMessage(text)
      setStatus('revealed')
      trackEvent('tool_generate', { tool: 'burn_message_reveal' })
    } catch {
      setStatus('error')
    }
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas/texto-temporario" className="tool-back-link">
        ← Enviar um novo texto temporário
      </Link>
      <h1>Ler Texto Temporário</h1>

      {status === 'idle' && (
        <>
          <p className="tool-disclaimer">
            Esta mensagem só pode ser aberta <strong>uma única vez</strong>.
            Depois de revelar, ela é apagada para sempre  não dá pra abrir
            de novo, nem atualizando a página.
          </p>
          <button type="button" className="tool-button" onClick={reveal}>
            Revelar mensagem
          </button>
        </>
      )}

      {status === 'loading' && <p>Descriptografando...</p>}

      {status === 'revealed' && (
        <div className="tool-result-card" style={{ flexDirection: 'column', alignItems: 'stretch' }}>
          <span className="tool-result-label">Mensagem</span>
          <span className="tool-result-value" style={{ whiteSpace: 'pre-wrap' }}>
            {message}
          </span>
        </div>
      )}

      {status === 'gone' && (
        <p className="tool-error">
          Essa mensagem já foi lida antes (ou nunca existiu)  não é mais
          possível recuperá-la.
        </p>
      )}

      {(status === 'invalid' || status === 'error') && (
        <p className="tool-error">
          Esse link parece incompleto ou inválido.
        </p>
      )}

      <div className="tool-info-section">
        <h2>Como essa mensagem fica protegida</h2>
        <p>
          O texto é criptografado (AES-GCM) direto no navegador de quem
          criou o link, antes de qualquer coisa ser enviada. A chave de
          decifragem vai só na parte do link depois do <code>#</code>
          essa parte da URL nunca é enviada para nenhum servidor, nem
          para este site, então nem nós conseguimos ler o conteúdo.
        </p>
        <p>
          Quando alguém clica em "Revelar", o texto cifrado é apagado do
          banco de dados no mesmo instante em que é lido  por isso não
          dá pra abrir a mesma mensagem duas vezes, nem atualizando a
          página.
        </p>
        <p>
          Quer enviar sua própria mensagem temporária?{' '}
          <Link to="/ferramentas/texto-temporario">
            Crie um link aqui
          </Link>
          .
        </p>
      </div>
    </div>
  )
}

export default BurnMessageReveal
